import state from './module-analysis-report-state';
import mutations from './module-analysis-report-mutations';
import actions from './module-analysis-report-actions';
import getters from './module-analysis-report-getters';

export default {
	debug: process.env.NODE_ENV !== 'production',
	namespaced: true,
	state,
	mutations,
	actions,
	getters
};
